import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  IconBolt,
  IconChartBar,
  IconChartHistogram,
  IconChartPie,
  IconDashboard,
  IconReport,
  IconSettingsAutomation,
  IconTable
} from '@tabler/icons';

import UI_MESSAGES from 'i18n/messages';
import { countUserDevices, isPlainUserRole, markMenuTourDone, shouldShowMenuTour } from 'utils/onboarding';

// Mismo orden que UI_MESSAGES.onboarding.tourItems.
const TOUR_ICONS = [
  IconDashboard,
  IconBolt,
  IconChartBar,
  IconChartHistogram,
  IconChartPie,
  IconTable,
  IconSettingsAutomation,
  IconReport,
  IconSettingsAutomation
];

// Muestra una sola vez (por usuario) el recorrido por el menú cuando un usuario con rol "User"
// llega a su primer datapoint después de haber visto la guía de alta.
const MenuTourGate = () => {
  const { userData, loading } = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);

  const userId = userData?.UserId;
  const canShow = !loading && isPlainUserRole(userData) && countUserDevices(userData) > 0 && shouldShowMenuTour(userId);

  useEffect(() => {
    if (canShow) {
      setOpen(true);
    }
  }, [canShow]);

  const handleClose = () => {
    markMenuTourDone(userId);
    setOpen(false);
  };

  const { tourTitle, tourIntro, tourItems, tourClose } = UI_MESSAGES.onboarding;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{tourTitle}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ mb: 1 }}>{tourIntro}</DialogContentText>
        <List dense>
          {tourItems.map((item, index) => {
            const Icon = TOUR_ICONS[index] || IconBolt;
            return (
              <ListItem key={item.title} alignItems="flex-start">
                <ListItemIcon sx={{ minWidth: 40, mt: 0.5 }}>
                  <Icon size={20} stroke={1.5} />
                </ListItemIcon>
                <ListItemText primary={item.title} secondary={item.description} />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          {tourClose}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MenuTourGate;
